<template>
  <div>
    <!--    Cabecera con parte del vídeo-->
    <section class="bg-primary py-5 bg-trama">
      <div class="container">
        <div class="row d-flex align-items-center">
          <div class="col-12 text-white my-5">
            <h1>Esto es… nuestro Mercado de San Miguel</h1>
          </div>

          <div class="col-12">
            <p class="subtitular text-white">
              Lo tienes clarísimo: no hay mejor plan que tomar el aperitivo en Malasaña, tapear por la Latina, cenar en
              Ponzano,...¡o hacer un mix de todo esto en algunos de los mercados más emblemáticos de Madrid, como el
              Mercado de San Miguel!
            </p>
            <p class="subtitular text-white">
              En la Sierra Norte también somos <strong>amantes del buen comer y del buen beber:</strong> ¡prueba los
              productos típicos de nuestra tierra y paladea el sabor de unas tradiciones únicas!
            </p>
          </div>
          <div class="col-12 mt-4">
            <img src="/img/icons/foodies.svg" alt="Planes especiales para foodies" class="mr-3" /><span
              class="text-black small"
              >Planes especiales para foodies</span
            >
          </div>
        </div>
      </div>
    </section>

    <!--      Fin de cabecera-->
    <!--      Sección con scroll horizontal-->

    <div id="scroll-wrapper" class="container-fluid scroll-wrapper bg-light">
      <div id="scrollContainer" class="scroll-sections">
        <div id="fondo-puntos" style="overflow: hidden;width:50px;position:absolute;height: 100vh;left:70vh">
          <img src="/img/caminos/camino-1.svg" alt="" style="position: absolute;top:30%;z-index:2" />
        </div>

        <div class="row scroll-section d-flex align-items-center">
          <div class="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
            <h2 class="mb-4">Te conquistaremos por el estómago</h2>
            <p class="subtitular z-index-up">
              En la Sierra Norte de Madrid cuidamos con esmero nuestras señas de identidad:
              <strong>la naturalidad de nuestros parajes, que se traslada a la calidad de nuestros productos;</strong> y
              la ruralidad, artesanía y mimo de nuestros procesos, que los impregnan de un sabor auténtico. ¡Conoce
              algunos de nuestros productos locales!
            </p>
            <a href="https://www.sierranortemadrid.org/restaurantes/" class="btn btn-primary mr-3 mt-2" target="_blank">
              ¿Dónde comer?
            </a>
            <a href="https://www.sierranortemadrid.org/alojamiento/" class="btn btn-primary mt-2" target="_blank">
              ¿Dónde alojarse?
            </a>
          </div>
          <div class="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
            <div class="row">
              <div class="col-12 px-0 z-index-down">
                <img src="/img/rutas/ruta5/judiones.jpg" alt="" class="img-fluid" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">Judiones</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      Se trata de
                      <strong>unos de los productos estrella que se cultivan en la Comunidad de Madrid.</strong> En
                      concreto, se cosechan en los municipios de Horcajuelo de la Sierra, Montejo de la Sierra, La
                      Hiruela, Prádena del Rincón y Puebla de la Sierra.
                    </span>
                  </li>
                  <li>
                    <span>
                      La forma más popular de comerlos es en un guiso de judiones, patatas y carne, aunque también están
                      deliciosos incorporándolos a otros platos de cuchara.
                    </span>
                  </li>
                  <li>
                    <span>
                      <strong>En primavera y verano también puedes comerlos:</strong> ¡utilízalos en la elaboración de
                      ensaladas templadas y frescas!
                    </span>
                  </li>
                  <li>
                    <span>
                      Se trata de un alimento muy saludable, debido a su bajo contenido en grasa y su alto contenido en
                      fibra y proteínas, así como de calcio, hierro, potasio y magnesio.
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-invierno />
                  <icon-familias />
                  <icon-aventureros />
                </div>
              </div>
              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Judiones</h3>
                <p>
                  ¿Te gustan los platos de cuchara? ¡Tienes que probar los famosos judiones de la Sierra Norte de
                  Madrid!
                </p>
                <div class="mb-4">
                  <b-button v-b-modal.modal1 variant="secondary">Más información</b-button>
                </div>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-invierno />
                  <icon-familias />
                  <icon-aventureros />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--          Inicio "2" slider************-->
        <div class="row scroll-section d-flex align-items-center">
          <div class="col-lg-5 offset-lg-1 z-index-top mt-5 mt-lg-0">
            <div class="row flex-lg-column-reverse">
              <div class="col-12 px-0 z-index-up">
                <img src="/img/rutas/ruta5/carne-igp.jpg" alt="" class="img-fluid mt-0 mt-lg-3" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">IGP Carne de la Sierra de Guadarrama</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      Los secretos de la carne ternera y añojo de
                      <a href="https://carneguadarrama.com/" target="_blank" alt="IGP Sierra de Guadarrama"
                        >la Sierra de Guadarrama</a
                      >
                      se encuentran, principalmente, en
                      <strong>disponer de una zona territorial delimitada, emplear ejemplares de razas selectas</strong>
                      (avileña, charolais y limousine) y <strong>vigilar todo el proceso</strong> para garantizar la
                      máxima calidad, desde la crianza hasta la venta al consumidor.
                    </span>
                  </li>
                  <li>
                    <span>
                      La climatología de la Sierra permite que el pasto se conserve todo el verano y los animales puedan
                      alimentarse de esta forma hasta el invierno. E incluso en los meses de invierno, los animales se
                      siguen alimentando de forma natural, lo que se considera uno de los principales motivos por los
                      que la carne de esta zona es tan sabrosa.
                    </span>
                  </li>
                  <li>
                    <span>
                      En carne fresca, su aspecto es ligeramente húmedo, con un color rojo/rosáceo, textura firme e
                      infiltraciones de grasa en el interior del músculo, lo que le da jugosidad. En carne cocinada,
                      resulta jugosa a la masticación.
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-parejas />
                  <icon-aventureros />
                </div>
              </div>
              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">IGP Carne de la Sierra de Guadarrama</h3>
                <p>La carne de la Sierra de Guadarrama es famosa por su jugosidad y calidad, ¿quieres saber por qué?</p>
                <div class="mb-4">
                  <b-button v-b-modal.modal2 variant="secondary">Más información</b-button>
                </div>

                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-parejas />
                  <icon-aventureros />
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
            <div class="row">
              <div class="col-12 px-0 z-index-down">
                <img src="/img/rutas/ruta5/aceite.jpg" alt="" class="img-fluid" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">Aceite</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      ¿Sabías que en la Sierra Norte es posible encontrar aceite de oliva 100% madrileño? De hecho,
                      <strong>en Madrid se recogen cada año, aproximadamente, 18 millones de kilos de aceitunas</strong>
                      de las variedades manzanilla, castellana y cornicabra
                    </span>
                  </li>
                  <li>
                    <span>
                      ¿Te gustaría conocer su proceso de elaboración en profundidad? Puedes
                      <strong>visitar la almazara de Torremocha en grupos</strong> de al menos 10 personas, hasta 60
                      personas.
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="1h" />
                  <icon-familias />
                  <icon-todas-estaciones />
                  <icon-culturetas />
                </div>
              </div>
              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Aceite</h3>
                <p>
                  ¿Sabías que en Madrid también tenemos olivos? ¡Prueba un exquisito aceite de oliva 100% madrileño!
                </p>
                <div class="mb-4">
                  <b-button v-b-modal.modal3 variant="secondary">Más información</b-button>
                </div>

                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="1h" />
                  <icon-familias />
                  <icon-todas-estaciones />
                  <icon-culturetas />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--          Fin "2" slider ******************-->
        <!--          Inicio "3" slider************-->
        <div class="row scroll-section d-flex align-items-center">
          <div class="col-lg-5 offset-lg-1 z-index-top mt-5 mt-lg-0">
            <div class="row flex-lg-column-reverse">
              <div class="col-12 px-0 z-index-up">
                <img src="/img/rutas/ruta5/chocolate-rascafria.jpg" alt="" class="img-fluid mt-0 mt-lg-3" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">Chocolate</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      Si eres una persona golosa, seguro que el chocolate es una de tus debilidades. ¡Haz una parada en
                      Rascafría y disfruta de un delicioso
                      <a
                        href="https://www.chocolatenatural.com/"
                        target="_blank"
                        alt="Más información sobre chocolate natural"
                        >chocolate natural artesano!</a
                      >
                      Encontrarás <strong>chocolates de todas las variedades:</strong> puro, con leche y blanco,
                      combinado con frutos secos, frutos del bosque y frutas naturales, ¡e incluso especial para
                      celíacos y alérgicos al huevo!
                    </span>
                  </li>
                  <li>
                    <span>
                      Por razones climáticas, te aconsejamos que hagas tus compras en otoño, invierno o primavera.
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="30m" />
                  <icon-familias />
                  <icon-parejas />
                  <icon-todas-estaciones />
                </div>
              </div>

              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Chocolate</h3>
                <p>¡Haz una parada en Rascafría y disfruta de un delicioso chocolate natural artesano!</p>
                <div class="mb-4">
                  <b-button v-b-modal.modal4 variant="secondary">Más información</b-button>
                </div>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="30m" />
                  <icon-familias />
                  <icon-parejas />
                  <icon-todas-estaciones />
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
            <div class="row">
              <div class="col-12 px-0 z-index-down">
                <img src="/img/rutas/ruta5/queso.jpg" alt="" class="img-fluid" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">Queso</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      De camino a la
                      <a href="http://www.quesosdemadrid.es/" target="_blank" alt="Quesos Chorrera de San Mamés"
                        >Chorrera de San Mamés</a
                      >
                      es posible encontrar esta pequeña
                      <strong>quesería familiar, que elabora quesos artesanos</strong> de pura leche de cabra y de oveja
                      de su propia ganadería.
                    </span>
                  </li>
                  <li>
                    <span>
                      De camino a Patones, desvíate hacia Torremocha del Jarama y en Torrearte descubrirás la fábrica de
                      <a href="https://www.queseriajaramera.com/" target="_blank" alt="Qusería Jaramera"
                        >Quesería Jaramera,</a
                      >
                      en la que Lucía y Pedro te explicarán cómo elaboran sus
                      <strong>5 variedades de queso artesano.</strong> ¡No podrás resistirte a llevarte un bolsón!
                    </span>
                  </li>
                  <li>
                    <span>
                      En Bustarviejo también encontrarás queso de la zona. ¡El sabor de
                      <a
                        href="https://es-es.facebook.com/pg/LaCaperuzaBustarviejo/posts/"
                        target="_blank"
                        alt="Quesos la Caperuza"
                        >La Caperuza</a
                      >
                      no te dejará indiferente!
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="30m" />
                  <icon-todas-estaciones />
                  <icon-aventureros />
                </div>
              </div>
              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Queso</h3>
                <p>
                  La tradición y la naturalidad tienen sabor propio: los quesos artesanos de la Sierra Norte de Madrid.
                </p>
                <div class="mb-4">
                  <b-button v-b-modal.modal5 variant="secondary">Más información</b-button>
                </div>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="30m" />
                  <icon-todas-estaciones />
                  <icon-aventureros />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--          Fin "3" slider ******************-->

        <!--          Inicio "4" slider************-->
        <div class="row scroll-section d-flex align-items-center">
          <div class="col-lg-5 offset-lg-1 z-index-top my-5 my-lg-0">
            <div class="row flex-lg-column-reverse">
              <div class="col-12 px-0 z-index-up ">
                <img src="/img/rutas/ruta5/cerveza-artesana.jpg" alt="" class="img-fluid mt-0 mt-lg-3" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">Cerveza artesana</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      Si te gusta la cerveza, no debes dejar de
                      <strong
                        >visitar la
                        <a
                          href="https://www.sierranortemadrid.org/cerveza-artesana-visita-y-cata/"
                          target="_blank"
                          alt="Más información sobre la cata de cerveza"
                          >fábrica de cerveza artesana de Bustarviejo</a
                        >
                        y realizar una cata de distintas variedades,</strong
                      >
                      ¡con aperitivo incluido!
                    </span>
                  </li>
                  <li>
                    <span>
                      Consejos adicionales: es necesaria reserva previa, con un número mínimo de 6 asistentes y un
                      máximo de 15. Además, recomendamos avisar si se sufre alguna intolerancia alimentaria (todas las
                      cervezas tienen gluten, por lo que no son aptas para celíacos).
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="90m" />
                  <icon-culturetas />
                  <icon-parejas />
                  <icon-todas-estaciones />
                </div>
              </div>
              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Cerveza artesana</h3>
                <p>
                  La cerveza nunca pasa de moda pero, sin duda, elaborarla de forma artesanal es tendencia. ¡Pruébala!
                </p>
                <div class="mb-4">
                  <b-button v-b-modal.modal6 variant="secondary">Más información</b-button>
                </div>

                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="90m" />
                  <icon-culturetas />
                  <icon-parejas />
                  <icon-todas-estaciones />
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
            <div class="row">
              <div class="col-12 px-0 z-index-down">
                <img src="/img/rutas/ruta5/vegetales.jpg" alt="" class="img-fluid" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none mb-4">
                <h3 class="mt-5 mb-3">Huerta ecológica (Bustarviejo)</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      ¡Nada como el sabor de las frutas y las verduras naturales! Si tú también eres de los que aprecian
                      el <strong>sabor de las frutas y verduras 100% ecológicas,</strong> no dejes de visitar
                      <a
                        href="https://www.sierranortemadrid.org/de-la-huerta-a-la-mesa/"
                        target="_blank"
                        alt="Más información sobre la huerta ecológica de Bustarviejo"
                        >la huerta ecológica de Bustarviejo.</a
                      >
                    </span>
                  </li>
                  <li>
                    <span>
                      En esta huerta <strong>se cultivan más de 45 especies comestibles:</strong> cebolletas,
                      remolachas, lechugas, fresas, acelgas, espárragos, espinacas, pimientos zanahorias, tomates,
                      judiones,... <strong>¿Su secreto? Agua de manantial, abonos propios y aire puro.</strong>
                    </span>
                  </li>
                  <li>
                    <span>
                      La encontrarás abierta todos los sábados de 11 a 14 horas.
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="30m" />
                  <icon-todas-estaciones />
                  <icon-familias />
                  <icon-influencers />
                </div>
              </div>
              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Huerta ecológica (Bustarviejo)</h3>

                <p>
                  ¿Recuerdas el sabor de los tomates “de antes”? ¡Pues en la Sierra Norte de Madrid es el de “recién
                  recogido”!
                </p>
                <div class="mb-4">
                  <b-button v-b-modal.modal7 variant="secondary">Más información</b-button>
                </div>

                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="30m" />
                  <icon-todas-estaciones />
                  <icon-familias />
                  <icon-influencers />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--          Fin "4" slider ******************-->
      </div>
    </div>
    <!--    Fin sección scroll horizontal-->
    <!--    Inicio modals-->

    <!--   Inicio Modal 1-->
    <b-modal id="modal1" centered scrollable size="lg" hide-footer title="Judiones">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                Se trata de
                <strong>unos de los productos estrella que se cultivan en la Comunidad de Madrid.</strong> En concreto,
                se cosechan en los municipios de Horcajuelo de la Sierra, Montejo de la Sierra, La Hiruela, Prádena del
                Rincón y Puebla de la Sierra.
              </span>
            </li>
            <li>
              <span>
                La forma más popular de comerlos es en un guiso de judiones, patatas y carne, aunque también están
                deliciosos incorporándolos a otros platos de cuchara.
              </span>
            </li>
            <li>
              <span>
                <strong>En primavera y verano también puedes comerlos:</strong> ¡utilízalos en la elaboración de
                ensaladas templadas y frescas!
              </span>
            </li>
            <li>
              <span>
                Se trata de un alimento muy saludable, debido a su bajo contenido en grasa y su alto contenido en fibra
                y proteínas, así como de calcio, hierro, potasio y magnesio.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 1-->
    <!--   Inicio Modal 2-->
    <b-modal id="modal2" centered scrollable size="lg" hide-footer title="IGP Carne de la Sierra de Guadarrama">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                Los secretos de la carne ternera y añojo de
                <a href="https://carneguadarrama.com/" target="_blank" alt="IGP Sierra de Guadarrama"
                  >la Sierra de Guadarrama</a
                >
                se encuentran, principalmente, en
                <strong>disponer de una zona territorial delimitada, emplear ejemplares de razas selectas</strong>
                (avileña, charolais y limousine) y <strong>vigilar todo el proceso</strong> para garantizar la máxima
                calidad, desde la crianza hasta la venta al consumidor.
              </span>
            </li>
            <li>
              <span>
                La climatología de la Sierra permite que el pasto se conserve todo el verano y los animales puedan
                alimentarse de esta forma hasta el invierno. E incluso en los meses de invierno, los animales se siguen
                alimentando de forma natural, lo que se considera uno de los principales motivos por los que la carne de
                esta zona es tan sabrosa.
              </span>
            </li>
            <li>
              <span>
                En carne fresca, su aspecto es ligeramente húmedo, con un color rojo/rosáceo, textura firme e
                infiltraciones de grasa en el interior del músculo, lo que le da jugosidad. En carne cocinada, resulta
                jugosa a la masticación.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 2-->
    <!--   Inicio Modal 3-->
    <b-modal id="modal3" centered scrollable size="lg" hide-footer title="Aceite">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                <strong>En Madrid se recogen cada año, aproximadamente, 18 millones de kilos de aceitunas</strong>
                de las variedades manzanilla, castellana y cornicabra
              </span>
            </li>
            <li>
              <span>
                ¿Te gustaría conocer su proceso de elaboración en profundidad? Puedes
                <strong>visitar la almazara de Torremocha en grupos</strong> de al menos 10 personas, hasta 60 personas.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 3-->
    <!--   Inicio Modal 4-->
    <b-modal id="modal4" centered scrollable size="lg" hide-footer title="Chocolate">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                Si eres una persona golosa, seguro que el chocolate es una de tus debilidades. ¡Haz una parada en
                Rascafría y disfruta de un delicioso
                <a
                  href="https://www.chocolatenatural.com/"
                  target="_blank"
                  alt="Más información sobre chocolate natural"
                  >chocolate natural artesano!</a
                >
                Encontrarás <strong>chocolates de todas las variedades:</strong> puro, con leche y blanco, combinado con
                frutos secos, frutos del bosque y frutas naturales, ¡e incluso especial para celíacos y alérgicos al
                huevo!
              </span>
            </li>
            <li>
              <span>
                Por razones climáticas, te aconsejamos que hagas tus compras en otoño, invierno o primavera.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 4-->
    <!--   Inicio Modal 5-->
    <b-modal id="modal5" centered scrollable size="lg" hide-footer title="Queso">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                De camino a la
                <a href="http://www.quesosdemadrid.es/" target="_blank" alt="Quesos Chorrera de San Mamés"
                  >Chorrera de San Mamés</a
                >
                es posible encontrar esta pequeña <strong>quesería familiar, que elabora quesos artesanos</strong> de
                pura leche de cabra y de oveja de su propia ganadería.
              </span>
            </li>
            <li>
              <span>
                De camino a Patones, desvíate hacia Torremocha del Jarama y en Torrearte descubrirás la fábrica de
                <a href="https://www.queseriajaramera.com/" target="_blank" alt="Qusería Jaramera"
                  >Quesería Jaramera,</a
                >
                en la que Lucía y Pedro te explicarán cómo elaboran sus
                <strong>5 variedades de queso artesano.</strong> ¡No podrás resistirte a llevarte un bolsón!
              </span>
            </li>
            <li>
              <span>
                En Bustarviejo también encontrarás queso de la zona. ¡El sabor de
                <a
                  href="https://es-es.facebook.com/pg/LaCaperuzaBustarviejo/posts/"
                  target="_blank"
                  alt="Quesos la Caperuza"
                  >La Caperuza</a
                >
                no te dejará indiferente!
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 5-->
    <!--   Inicio Modal 6-->
    <b-modal id="modal6" centered scrollable size="lg" hide-footer title="Cerveza artesana">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                Si te gusta la cerveza, no debes dejar de
                <strong
                  >visitar la
                  <a
                    href="https://www.sierranortemadrid.org/cerveza-artesana-visita-y-cata/"
                    target="_blank"
                    alt="Más información sobre la cata de cerveza"
                    >fábrica de cerveza artesana de Bustarviejo</a
                  >
                  y realizar una cata de distintas variedades,</strong
                >
                ¡con aperitivo incluido!
              </span>
            </li>
            <li>
              <span>
                Consejos adicionales: es necesaria reserva previa, con un número mínimo de 6 asistentes y un máximo de
                15. Además, recomendamos avisar si se sufre alguna intolerancia alimentaria (todas las cervezas tienen
                gluten, por lo que no son aptas para celíacos).
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 6-->
    <!--   Inicio Modal 7-->
    <b-modal id="modal7" centered scrollable size="lg" hide-footer title="Huerta ecológica (Bustarviejo)">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                ¡Nada como el sabor de las frutas y las verduras naturales! Si tú también eres de los que aprecian el
                <strong>sabor de las frutas y verduras 100% ecológicas,</strong> no dejes de visitar
                <a
                  href="https://www.sierranortemadrid.org/de-la-huerta-a-la-mesa/"
                  target="_blank"
                  alt="Más información sobre la huerta ecológica de Bustarviejo"
                  >la huerta ecológica de Bustarviejo.</a
                >
              </span>
            </li>
            <li>
              <span>
                En esta huerta <strong>se cultivan más de 45 especies comestibles:</strong> cebolletas, remolachas,
                lechugas, fresas, acelgas, espárragos, espinacas, pimientos zanahorias, tomates, judiones,...
                <strong>¿Su secreto? Agua de manantial, abonos propios y aire puro.</strong>
              </span>
            </li>
            <li>
              <span>
                La encontrarás abierta todos los sábados de 11 a 14 horas.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 7-->
    <!--    Fin de modal-->
  </div>
</template>

<script>
import { TimelineMax } from 'gsap'

export default {
  components: {
    IconTime: () => import('../../components/iconos/IconTime'),
    IconCulturetas: () => import('../../components/iconos/IconCulturetas'),
    // IconVerano: () => import('../../components/iconos/IconVerano'),
    // IconDistance: () => import('../../components/iconos/IconDistance'),
    IconFamilias: () => import('../../components/iconos/IconFamilias'),
    // IconFoodies: () => import('../../components/iconos/IconFoodies'),
    IconInfluencers: () => import('../../components/iconos/IconInfluencers'),
    IconInvierno: () => import('../../components/iconos/IconInvierno'),
    // IconOtono: () => import('../../components/iconos/IconOtono'),
    IconParejas: () => import('../../components/iconos/IconParejas'),
    // IconPrimavera: () => import('../../components/iconos/IconPrimavera'),
    IconTodasEstaciones: () => import('../../components/iconos/IconTodasEstaciones'),
    IconAventureros: () => import('../../components/iconos/IconAventureros')
  },
  mounted() {
    if (window.innerWidth > 1000) {
      const horizontalSlide = new TimelineMax().to('#scrollContainer', 1, { x: '-60%' })
      const scene = this.$scrollmagic
        .scene({
          triggerElement: '#scroll-wrapper',
          triggerHook: 'onLeave',
          duration: '400%'
        })
        .setPin('#scroll-wrapper')
        .setTween(horizontalSlide)
      const scene2 = this.$scrollmagic
        .scene({
          triggerElement: '#scroll-wrapper',
          triggerHook: 'onLeave',
          duration: '400%'
        })
        .setTween('#fondo-puntos', {
          width: '70%'
        })

      this.$scrollmagic.addScene(scene)
      this.$scrollmagic.addScene(scene2)
    }
  }
}
</script>
